<div class="headerig">
  <div class="btnsaveig ui-btn ui-btn--primary ui-btn--auto"
       [class.ui-btn--disabled]="!hasChanges() || saving()"
       (click)="save()">
    @if (saving()) {
      Sauvegarde en cours...
    } @else {
      <i class="fas fa-save"></i>&nbsp; Sauvegarder
    }
  </div>
  @if (hasChanges()) {
    <div class="blocmodif">
      {{ changeCount() }} modification{{ changeCount() > 1 ? 's' : '' }} non-sauvegardée{{ changeCount() > 1 ? 's' : '' }}
      <span class="annulmod" (click)="cancel()"><i class="fa-solid fa-xmark"></i></span>
    </div>
  }
  <div class="contpublish">
    <span class="txtetatig">{{ savingPublish() ? 'Sauvegarde...' : 'Statut :' }}</span>
    <input type="checkbox" id="inpublish" [class.inchon]="actif()" [checked]="actif()" (change)="togglePublish()">
    <label for="inpublish" class="labpublish">
      &nbsp; &nbsp; <div class="barpublish"><span class="circlepublish"></span></div>
    </label>
  </div>
</div>
<div class="contgloig">
  <div class="contblocig">
    <div class="blocig ui-card">
      <div class="hbig ui-card__header--bordered">
        Informations principales :
      </div>
      <div class="liformig ui-form-group">
        <div class="labelig ui-form-label">
          <i class="fa-duotone fa-light fa-input-text"></i> &nbsp;Nom de la liste
        </div>
        <input type="text" class="inig" id="inname" placeholder="Titre"
               [value]="listName()" (input)="listName.set($any($event.target).value)">
        @if (nameError()) {
          <div class="ui-form-error">{{ nameError() }}</div>
        }
      </div>
      <div class="liformig ui-form-group">
        <div class="labelig ui-form-label">
          <i class="fa-duotone fa-light fa-calendar"></i> &nbsp;Date de fin de validité de la liste
        </div>
        <input class="inig" id="indate" type="datetime-local"
               [value]="listDate()" (change)="listDate.set($any($event.target).value)">
      </div>
    </div>
    <div class="blocig ui-card">
      <div class="hbig ui-card__header--bordered">
        Informations complémentaires :
      </div>
      <div class="liformig ui-form-group">
        <div class="labelig ui-form-label">
          <i class="fa-duotone fa-light fa-swatchbook"></i> &nbsp;Couleur d'identification
        </div>
        <select class="inig" id="intag"
                [value]="colorTag()" (change)="colorTag.set($any($event.target).value)">
          <option value="0">Aucune couleur</option>
          <option value="1">Orange</option>
          <option value="2">Jaune</option>
          <option value="3">Vert</option>
          <option value="4">Bleu</option>
          <option value="5">Violet</option>
          <option value="6">Rose</option>
          <option value="7">Rouge</option>
        </select>
      </div>
      <div class="liformig ui-form-group">
        <div class="labelig ui-form-label">
          <i class="fa-duotone fa-light fa-pen-clip"></i> &nbsp;Description de la liste
        </div>
        <textarea class="inig" id="indescri" placeholder="Ex : Liste de samedi pour les entrées VIP.  (facultatif)" style="min-width:97%;max-width:97%;height:130px;min-height:50px;max-height:200px"
                  [value]="description()" (input)="description.set($any($event.target).value)"></textarea>
      </div>
      <div class="liformig ui-form-group">
        <div class="labelig ui-form-label">
          <i class="fa-duotone fa-light fa-nfc-signal"></i> &nbsp;Associer avec un support cashless
        </div>
        <select class="inig" id="innfcmode"
                [value]="nfcMode()" (change)="nfcMode.set($any($event.target).value)">
          <option value="disabled">Désactivé</option>
          <option value="optional">Optionnel</option>
          <option value="required">Obligatoire</option>
        </select>
      </div>
    </div>
  </div>
  <div class="contcodig">
    <div class="hbig titframe" style="border-color:var(--ui-color-border);margin-bottom: 0px;">
    Associer à des accès :
    </div>
    <div class="contintegration">
      <div class="txtintegration">
        Sélectionnez, ci-dessous, les points d'accès autorisés à contrôler les tarifs présents dans cette liste.
        <span class="tir"></span><span class="linktoga" routerLink="/gerer-les-acces">Gérer les accès</span>.
      </div>
    </div>
    <div class="contlistpa">
      <div class="listpa">
        @for (key of keys(); track key._id) {
          <input type="checkbox" class="inCheckPa" [id]="key._id"
                 [checked]="key.enabled" (change)="toggleKey(key._id)">
          <label class="itPa" [class.bankeyPa]="key.ban" [for]="key._id">
            <div class="bulCheckPa"><i class="fas fa-check icCheckPa"></i>{{ key.initials }}</div>
            <div class="banfilterPa"><i class="fas fa-eye-slash"></i></div>
            <div class="namePa">{{ key.name }}</div>
          </label>
        }
        <div class="itaddPa" routerLink="/gerer-les-acces">
          <div class="buladdPa"><i class="fa-solid fa-plus"></i></div>
          <div class="nameaddPa">Créer un accès</div>
        </div>
      </div>
    </div>
  </div>
</div>
@if (showPopup()) {
  <div class="fdpopedit" (click)="closePopup()"></div>
  <div class="popinfocode">
    <span style="font-weight:800;font-size:16px;text-decoration:underline">Étapes à suivre pour intégrer votre module cashless :</span>
    <br><br>
    <p style="font-size:14px;color:var(--ui-color-text-muted)">
    1 - Copier le code fournit.
    <br><br>
    2 - Accédez au code html de votre site internet.
    <br><br>
    3 - Coller le code dans une des pages de votre votre site et à l'intérieur d'un bloc, par exemple entre une balise "div" et une balise "/div".
    <br><br>
    4 - Veillez à ce que le bloc récepteur soit visible et assez large pour afficher l'intégralité du module.
    <br><br>
    5 - Enregistrez vos modifications et accèdez à votre page pour vérifier que votre module est bien accessible et correctement affiché.
    </p>
    <br><br>
    <span style="font-weight:800;font-size:16px;text-decoration:underline">Quelques conseils :</span>
    <br><br>
    <p style="font-size:14px;color:var(--ui-color-text-muted)">
      <span style="font-weight:800;font-size:15px;">Personnalisation : </span>
      <br><br>
      Vous pouvez effectuer des modifications dans le code fournit pour personnaliser votre widget. Vous pouvez par exemple changer les couleurs, les dimensions, les bordures, etc...
      <br><br>
      <i class="far fa-exclamation-triangle"></i> &nbsp;Attention toutefois, une mauvaise manipulation peut engendrer des bugs techniques. Ne modifier le code de votre widget que si vous êtes certain des changements apportés et du code ajouté.
      <br><br><br>
      <span style="font-weight:800;font-size:15px;">Intégration : </span>
      <br><br>
      Assurez vous des spécificités du bloc dans lequel vous collez le code du widget. Le bloc doit avoir une largeur minimale de 350px et une hauteur minimale de 300px.
      <br>
      <span style="text-decoration: underline">Dimensions conseillées :</span> 750px (largeur) x 600px (hauteur).
      <br><br>
      <i class="far fa-exclamation-triangle"></i> &nbsp;L'affichage sur smartphone est très souvent différent, les blocs de votre site sont compressés et cela peut engendrer des problèmes d'utilisation du module si la largeur est trop petite.
      Verifier donc également les dimensions sur mobile et assurez vous que le module soit entièrement visible et accessible.
      <br><br><br>
      <span style="font-weight:800;font-size:15px;">Wordpress : </span>
      <br><br>
      Pour facilement intégrer votre widget cashless sur une site Wordpress vous pouvez vous servir de l'édition d'article.
      <br>
      Vous devez créer un nouvel article, puis dans l'éditeur de texte, passer au mode "texte enrichi" ou "texte html" et enfin coller le code dans le paneau de texte et enregistrer.
      <br><br><br>
      <span style="font-weight:800;font-size:15px;">Accompagnement : </span>
      <br><br>
      Si vous rencontrez des difficultés n'hésitez pas à contacter notre équipe. Elle se fera un plaisir de vous guider dans l'intégration et l'utilisation de votre widget cashless.
    </p>
    <br><br>
  </div>
}
